/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientsNewGroup', function($scope, $rootScope, $stateParams, recipientgroupService,
    $q, recipientService, _$editmode, _$privileges) {

    _$editmode.turnOn();

    $scope.id = $stateParams.id;

    $scope.list = {};

    $scope.row = {
        'group_name': '',
        'description': '',
        'active': 0,
        'filter': {
            'sex': null,
            'name': '',
            'surname': '',
            'street': '',
            'postcode': '',
            'comunity': '',
            'city': '',
            'age': '',
            'age_before': null,
            'age_after': null
        }
    };

    $scope.data = {
        "age_before": "",
        "age_after": "",
        "copy_group_name": "",
        "can_write": _$privileges.write("message"),
        "user_id": "",
        "activeNotifications": []
    };

    $scope.tab = {
        "title": $scope.id ? "Edycja grupy odbiorców" : "Nowa grupa odbiorców",
        "type": $scope.id ? "edit" : "add",
        "selected": 0,
        "editable": true,
        "change": function(kind, form) {
            var result = true;
            if ($scope.tab.editable && typeof form != "undefined") {
                result = $scope.check(form);
            }
            if (result)
                $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        }
    };

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.check = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });

            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.save = function(form) {
        var params = angular.copy($scope.row);
        if ($scope.autocompletes.city.length > 0)
            params.filter.city = _.map($scope.autocompletes.city, 'name').join();
        if ($scope.autocompletes.county.length > 0)
            params.filter.county = _.map($scope.autocompletes.county, 'name').join();
        if ($scope.autocompletes.comunity.length > 0)
            params.filter.comunity = _.map($scope.autocompletes.comunity, 'name').join();
        if ($scope.autocompletes.street.length > 0)
            params.filter.street = _.map($scope.autocompletes.street, 'name').join();

        var promise = $scope.id ? recipientgroupService.update($scope.id, params) : recipientgroupService.store(params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    $rootScope.notification.showAfterRedirect('message_rcgroup', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd ' + ($scope.id ? 'edycji' : 'dodawania') + ' grupy odbiorców');
            });
    };

    $scope.search = function() {
        var params = angular.copy($scope.row.filter);

        if ($scope.autocompletes.city.length > 0)
            params.city = _.map($scope.autocompletes.city, 'name').join();
        if ($scope.autocompletes.county.length > 0)
            params.county = _.map($scope.autocompletes.county, 'name').join();
        if ($scope.autocompletes.comunity.length > 0)
            params.comunity = _.map($scope.autocompletes.comunity, 'name').join();
        if ($scope.autocompletes.street.length > 0)
            params.street = _.map($scope.autocompletes.street, 'name').join();

        params.active = 1;
        params.verified = 1;
        params.contact = 1;

        var promise = recipientService.list(1, params);
        promise.then(
            function(payload) {
                $scope.list = payload.data;
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd pobierania listy odbiorców po filtrowaniu');
            });
    };

    $scope.init = function() {
        var promise = $scope.id ? recipientgroupService.edit($scope.id) : recipientgroupService.create();
        promise.then(
            function(payload) {

                $scope.list = payload.data.list;
                $scope.data.activeNotifications = payload.data.activeNotifications;
                
                if ($scope.id) {
                    if (payload.data.row.length == 0) {
                        $rootScope.notification.showAfterRedirect('message_rcgroup', {}, 'error', 'Podana grupa odbiorców nie została odnaleziona');
                    } else {
                        $scope.row = payload.data.row;
                        $scope.data.user_id = payload.data.user_id;
                    }

                    var county = $scope.row.filter.county;
                    if (county) {
                        county = county.split(",");
                        for (var i = 0; i < county.length; i++) {
                            if (county[i] != "") {
                                $scope.autocompletes.county.push({
                                    name: county[i]
                                });
                            }
                        }
                    }

                    var comunity = $scope.row.filter.comunity;
                    if (comunity) {
                        comunity = comunity.split(",");
                        for (var i = 0; i < comunity.length; i++) {
                            if (comunity[i] != "") {
                                $scope.autocompletes.comunity.push({
                                    name: comunity[i]
                                });
                            }
                        }
                    }

                    var city = $scope.row.filter.city;
                    if (city) {
                        city = city.split(",");
                        for (var i = 0; i < city.length; i++) {
                            if (city[i] != "") {
                                $scope.autocompletes.city.push({
                                    name: city[i]
                                });
                            }
                        }
                    }

                    var street = $scope.row.filter.street;
                    if (street) {
                        street = street.split(",");
                        for (var i = 0; i < street.length; i++) {
                            if (street[i] != "") {
                                $scope.autocompletes.street.push({
                                    name: street[i]
                                });
                            }
                        }
                    }
                }

                if (typeof $scope.row != "undefined" && $scope.row.filter.age != null && $scope.row.filter.age != "") {
                    var age = $scope.row.filter.age.split("_");
                    if (age[0] == "date") {
                        $scope.row.filter.age_before = new Date($scope.row.filter.age_before);
                        if ($scope.row.filter.age_after != "")
                            $scope.row.filter.age_before = new Date($scope.row.filter.age_before);
                    } else {
                        $scope.row.filter.age_before = parseInt($scope.row.filter.age_before, 10);
                        if ($scope.row.filter.age_after != "")
                            $scope.row.filter.age_after = parseInt($scope.row.filter.age_after, 10);
                    }
                }
            },
            function(errorPayload) {
                $rootScope.notification.showAfterRedirect('recipients', {}, 'error', 'Błąd wyświetlania listy odbiorców');
            });
    };

    $scope.init();

    $scope.ageChange = function() {
        $scope.row.filter.age_before = "";
        $scope.row.filter.age_after = "";
    };
});
